import { render, staticRenderFns } from "./BaseIconButtonSend.vue?vue&type=template&id=2b7be91b&scoped=true&"
import script from "./BaseIconButtonSend.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7be91b",
  null
  
)

export default component.exports